import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const RadarFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18ZM4.78 11.96C4.78 15.94 8.04 19.22 12 19.22C15.96 19.22 19.22 15.94 19.22 11.96H17.46C17.46 14.9 14.96 17.36 12 17.36C9.04 17.36 6.54 14.9 6.54 11.96C6.54 9.02 9.04 6.56 12 6.56C13.14 6.56 14.22 6.9 15.2 7.62L16.52 6.3C15.16 5.26 13.66 4.7 12 4.7C8.04 4.7 4.78 7.98 4.78 11.96ZM12 14.1C10.82 14.1 9.86 13.14 9.86 11.96C9.86 10.78 10.82 9.82 12 9.82C12.24 9.82 12.48 9.86 12.82 10L14.16 8.68C13.46 8.22 12.74 8.02 12 8.02C9.84 8.02 8.1 9.8 8.1 11.96C8.1 14.12 9.84 15.9 12 15.9C14.16 15.9 15.9 14.12 15.9 11.96H14.14C14.14 13.14 13.18 14.1 12 14.1Z" />
    </SvgIcon>
  );
});
